import { EntityDto, IEntityDto } from "../../../utils/models/entity-dto";
import { FieldType } from "@gbs-platform-client/fwk-core";


export class Department extends EntityDto implements IEntityDto {
  Department_Id: string;
  DepartmentName: string;
  DepartmentPrefix: string;
  EmailId: string;
  Phone: string;
  Company_Id: string;
  CompanyName: string;
  Division_Id: string;
  DivisionName: string;
  Location_Id: string;
  LocationName: string;
  TotalCount: number;
  IsActive: boolean;
  Emp_Ref_Id: string;
  EmployeeName: string;
  ParentDepartment_Id:string;
  ParentDepartmentName: string;
  WorkFlowDepartment_Id:string;
  constructor() {
    super();
    this.Department_Id = '00000000-0000-0000-0000-000000000000';
    this.DepartmentName = '';
    this.DepartmentPrefix = '';
    this.Company_Id = "";
    this.CompanyName = "";
    this.Division_Id = "";
    this.DivisionName = "";
    this.Location_Id = '';
    this.LocationName = '';
    this.EmailId = '';
    this.Phone = '';
    this.Emp_Ref_Id = '';
    this.EmployeeName = '';
    this.TotalCount = 0;
    this.IsActive = true;
    this.ParentDepartment_Id = '';
    this.ParentDepartmentName = '';
    this.WorkFlowDepartment_Id='00000000-0000-0000-0000-000000000000';
    this.EntityMetaData = [
      { FieldName: 'DepartmentName', FieldType: FieldType.String, IsMandatory: true, ValidationMessage: ' Department Name is required' },
      //{ FieldName: 'Location_Id', FieldType: FieldType.String, IsMandatory: true, ValidationMessage: 'Location is required' },
      { FieldName: 'DepartmentPrefix', FieldType: FieldType.String, IsMandatory: true, ValidationMessage: 'Code is required' },
      // { FieldName: 'EmailId', FieldType: FieldType.String, IsMandatory: true, ValidationMessage: 'Email Id is required' },
      // { FieldName: 'Phone', FieldType: FieldType.String, IsMandatory: true, ValidationMessage: 'Phone is required' },
      //{ FieldName: 'Emp_Ref_Id', FieldType: FieldType.String, IsMandatory: true, ValidationMessage: 'Department Head is required' },

    ];
  }
}